import request from "../utils/fetch";

//月账单
export function monthBill(data) {
  return request({
    url: "/order/enterprise/order/share/bill/month/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//日账单
export function dayBill(data) {
  return request({
    url: "/order/enterprise/order/share/bill/day/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 头部数据
export function topData2(data) {
  return request({
    url: "/order/enterprise/order/share/all",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 头部数据
export function topData(data) {
  return request({
    url: "/order-common/enterprise/wallet/withdraw/all",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//提交前获取银行信息
export function acquire(data) {
  return request({
    url: "/company/company/enterprise/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 提现提交
export function withdraw(data) {
  return request({
    url: "/order-common/enterprise/wallet/withdraw/apply",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//提现记录
export function withdraw_jl(data) {
  return request({
    url: "/order-common/enterprise/wallet/withdraw/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function fenrunShou(data) {
  return request({
    url: "/order/enterprise/order/share/region/statistics",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 收益明细
export function shouyiDetail(data) {
  return request({
    url: "/order/enterprise/order/share/wallet/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 收益提现--收益明细
export function txShouyiDetail(data) {
  return request({
    url: "/order-common/customer/wallet/source/wallet/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// t提现账户下拉
export function zhanghu(data) {
  return request({
    url: "/user/comany/bank/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function kfDetail(data) {
  return request({
    url:
      "/order/order/air/share/bill/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function allStic(data) {
  return request({
    url: "/order/order/air/share/bill/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 导出
export function ExportShareNum(data) {
  return request({
    url:
      "/order/order/air/share/bill/export?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    // header: {
    //   headers: { "Content-Type": "application/x-download" },
    // },
    // responseType: "blob",
  });
}

export function ExportShareNumDownload(data) {
  return request({
    url:
      "/order/order/air/share/bill/export?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}
